var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFieldVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.211,2.024c8.48-.519,15.808,7.442,13.431,15.715-2.023,7.043-8.051,13.883-12.163,19.867-.441.514-.669.309-1.053-.096-1.3-1.371-2.892-3.819-4.023-5.42-2.743-3.885-8.119-11.753-8.481-16.386-.555-7.099,5.176-13.244,12.29-13.679ZM29.77,20.773c6.175-5.924.21-16.083-8.15-13.681-6.034,1.733-7.969,9.431-3.389,13.681.379-1.486,1.338-2.758,2.646-3.573,1.865,1.383,4.378,1.386,6.247,0,1.324.794,2.261,2.096,2.646,3.573Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.06,41.638l1.062-6.254,8.195.015c1.672,1.472,2.777,5.387,5.672,4.228,1.267-.507,2.512-3.14,3.483-4.151l.281-.102,7.937.007,1.058,6.258h-19.468c-.325,0-1.009.475-1.009.806v3.556h-4.422v-3.651c0-.235-.661-.711-.913-.711h-1.875Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.728,43.629c.001.722.608,1.405.006,2.045-.093.099-.426.326-.535.326h-25.91v-2.371h26.439Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.151,41.638h-5.48l-2.019-12.044h4.182c.218,0,.678.599.675.852l2.642,11.192Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.156,29.593l-2.019,12.044H2.849l2.717-11.403c.004-.194.464-.641.6-.641h3.99Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.925,43.629v2.371H2.801c-.109,0-.442-.227-.535-.326-.602-.64.005-1.323.006-2.045h8.653Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.943 33.482 11.502 33.482 12.079 29.594 15.281 29.611 17.943 33.482"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.057,33.482c-.036-.155.031-.219.094-.334.63-1.16,1.828-2.306,2.425-3.534l3.152-.019.578,3.887h-6.249Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.592,10.367c3.992-.517,4.687,5.448.929,5.942-4.213.554-4.799-5.44-.929-5.942Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFieldVisit);
export default __webpack_public_path__ + "static/media/icon-field-visit.86faf5952cc2fa077eea91c49349d634.svg";
export { ForwardRef as ReactComponent };